export const INITIAL_RESET_RECORD_KEY = '__INITIAL_STATE';
export const NO_RESET_KEY = '';
export const ROOT_RESET_RECORD_KEY = '__ROOT';
export const STORAGE_RESET_KEY = '__STORAGE_RESET_KEY';
